import { matchPath } from 'react-router-dom';

/**
 * Whether the URL of a request points at a given route.
 *
 * Uses the router's own matcher rather than comparing pathnames, so a route pattern
 * (`/update-vehicle/:vehicleId`) matches, a trailing slash still matches the route it
 * names, and the query string is ignored. The match is exact: a pathname below the
 * route is not the route.
 */
export const isRoute = (url: string, path: string): boolean =>
  matchPath(path, new URL(url).pathname) !== null;
